(() => {
  'use strict';
  const root = document.getElementById('RaCappelloPromotion');
  if (!root || window.raCappelloPromoInitialized) return;
  window.raCappelloPromoInitialized = true;
  const dialog = document.getElementById('RaCappelloDialog');
  const deadline = Number(root.dataset.deadline);
  const serverNow = Number(root.dataset.serverNow);
  const loadedAt = performance.now();
  const now = () => serverNow + performance.now() - loadedAt;
  const productId = Number(root.dataset.productId);
  // Code extension and hair collections never open the popup.
  const popupAllowed = root.dataset.popup !== 'false';
  const sessionKey = 'ra-cappello-collection-' + deadline;
  let clockTimer;
  let fetchSerial = 0;
  let giftInCart = false;
  let cartInteraction = false;
  const close = () => { if (dialog.open) dialog.close(); };
  const active = () => now() < deadline;
  const syncDrawerPromo = () => {
    const drawer = document.getElementById('MinimogCartDrawer');
    if (!drawer) return;
    const cards = Array.from(drawer.querySelectorAll('.ra-cappello--drawer'));
    const card = drawer.querySelector('#MinimogCartDrawerFooter .ra-cappello--drawer') || cards[0];
    const link = drawer.querySelector('.m-cart-drawer__link-to-cart');
    cards.forEach(node => { if (node !== card) node.remove(); });
    // The mobile cart moves its view-cart link into the scrollable summary.
    // Keep the same single card with that link after each native Ajax render.
    if (card && link && link.nextElementSibling !== card) link.after(card);
  };
  // Countdown under the hat line, on the cart page and in the cart drawer.
  // Re-added after each native Ajax render of the cart.
  const syncItemTimers = () => {
    document.querySelectorAll('[data-cart-item][data-product-id="' + productId + '"]').forEach(item => {
      if (item.querySelector('[data-ra-cappello-item-timer]')) return;
      const title = item.querySelector('.m-cart-item__title');
      if (!title) return;
      const timer = document.createElement('div');
      timer.className = 'ra-cappello__countdown ra-cappello__countdown--item';
      timer.setAttribute('data-ra-cappello', '');
      timer.setAttribute('data-ra-cappello-clock', '');
      timer.setAttribute('data-ra-cappello-item-timer', '');
      timer.innerHTML = '<span>Solo fino a mezzanotte</span><span class="ra-cappello__digits" data-ra-cappello-digits role="timer" aria-live="off">00:00:00</span>';
      title.after(timer);
    });
  };
  const tick = () => {
    const seconds = Math.max(0, Math.floor((deadline - now()) / 1000));
    if (!seconds) {
      clearInterval(clockTimer);
      close();
      document.querySelectorAll('[data-ra-cappello]').forEach(node => node.remove());
      return false;
    }
    syncDrawerPromo();
    syncItemTimers();
    const clock = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
    document.querySelectorAll('[data-ra-cappello-digits]').forEach(node => {
      if (node.textContent !== clock) node.textContent = clock;
      node.closest('[data-ra-cappello-clock]').hidden = false;
    });
    return true;
  };
  const open = () => {
    if (!popupAllowed || !active() || giftInCart || cartInteraction || dialog.open || document.querySelector('dialog[open], #MinimogCartDrawer.m-cart-drawer--active')) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
  };
  const readCart = async () => {
    const serial = ++fetchSerial;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (serial !== fetchSerial) return;
      giftInCart = cart.items.some(item => Number(item.product_id) === productId);
      if (giftInCart) close();
      return cart;
    } catch (_) {}
  };
  dialog.querySelectorAll('[data-ra-cappello-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !active()) return;
    const path = new URL(form.action || location.href, location.href).pathname;
    if (!/\/cart\/add(?:\.js)?$/.test(path)) return;
    cartInteraction = true;
    close();
    setTimeout(() => { readCart(); tick(); }, 700);
  }, true);
  const onCartUpdate = data => {
    if (!active()) return;
    const addedItems = data?.product_id ? [data] : (!data?.token && Array.isArray(data?.items) ? data.items : []);
    cartInteraction = true;
    const addedGift = addedItems.some(item => Number(item.product_id) === productId);
    if (addedGift) giftInCart = true;
    close();
    readCart().then(() => {
      tick();
    });
  };
  const start = async () => {
    if (!tick()) return;
    clockTimer = setInterval(tick, 1000);
    if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, onCartUpdate);
    }
    await readCart();
    if (root.dataset.page === 'collection' && popupAllowed) {
      let alreadyShown = false;
      try { alreadyShown = sessionStorage.getItem(sessionKey) === '1'; } catch (_) {}
      if (!alreadyShown && !giftInCart) {
        let elapsed = false;
        let scrolled = false;
        const initialScroll = window.scrollY;
        const tryCollectionPopup = () => {
          if (!elapsed || !scrolled || document.hidden || !active()) return;
          open();
          if (dialog.open) {
            window.removeEventListener('scroll', onCollectionScroll);
            document.removeEventListener('visibilitychange', tryCollectionPopup);
            try { sessionStorage.setItem(sessionKey, '1'); } catch (_) {}
          }
        };
        const onCollectionScroll = () => {
          if (window.scrollY > initialScroll + 80) scrolled = true;
          tryCollectionPopup();
        };
        window.addEventListener('scroll', onCollectionScroll, { passive: true });
        document.addEventListener('visibilitychange', tryCollectionPopup);
        setTimeout(() => { elapsed = true; tryCollectionPopup(); }, 5000);
      }
    }
  };
  window.addEventListener('pageshow', tick);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
